<template>
  <div class="loading-overlay">
    <img class="overlay-loader loading-spinner" :src="CONSTANTS.SPINNER_URL" alt="Loading Spinner">
  </div>
</template>
<script>
import CONSTANTS from "@/store/constants";
export default {
  name: 'LoadingSpinner',
  computed: {
  }
}
</script>

<style scoped>
.loading-overlay{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 1500px;
}
  .loading-overlay img {
    z-index: 10;
    display: block;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); 
    transform: -webkit-translate(-50%, -50%);
    transform: -moz-translate(-50%, -50%);
    transform: -ms-translate(-50%, -50%);
  }
  .loading-overlay p {
    display: block;
    font-size: 30px;
  }
</style>
